import React, { lazy } from 'react';
import { DollarSignIcon, HomeIcon } from 'lucide-react';
export function ComparisonSection() {
  return <section className="py-12 border-b border-gray-200" data-id="element-165">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-166">
        In-office treatment vs Oculis-3
      </h2>
      <p className="text-lg text-gray-700 mb-3 max-w-3xl" data-id="element-167">
        For years, specialists have relied on in-office devices like LipiFlow®.
        <br data-id="element-168" />
        <br data-id="element-169" />
        They apply controlled heat and gentle pressure to soften and move the natural oils that keep eyes comfortable.
        <br data-id="element-170" />
        <br data-id="element-171" />
        The temporary results can feel incredible but they come at a cost:
      </p>
      <div className="flex flex-col md:flex-row gap-8" data-id="element-172">
        <div className="md:w-1/2 bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-173">
          <div className="flex items-center mb-4" data-id="element-174">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mr-4" data-id="element-175">
              <DollarSignIcon className="w-6 h-6 text-red-500" data-id="element-176" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900" data-id="element-177">
              In-Office Treatment
            </h3>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-178">
            <li className="flex" data-id="element-179">
              <div className="text-red-500 mr-2" data-id="element-180">•</div>
              <p className="text-gray-700" data-id="element-181">
                <span className="font-medium" data-id="element-182">$800-$1600</span> per treatment
                session
              </p>
            </li>
            <li className="flex" data-id="element-183">
              <div className="text-red-500 mr-2" data-id="element-184">•</div>
              <p className="text-gray-700" data-id="element-185">
                Requires{' '}
                <span className="font-medium" data-id="element-186">multiple office visits</span>
              </p>
            </li>
            <li className="flex" data-id="element-187">
              <div className="text-red-500 mr-2" data-id="element-188">•</div>
              <p className="text-gray-700" data-id="element-189">
                Often{' '}
                <span className="font-medium" data-id="element-190">not covered by insurance</span>
              </p>
            </li>
            <li className="flex" data-id="element-191">
              <div className="text-red-500 mr-2" data-id="element-192">•</div>
              <p className="text-gray-700" data-id="element-193">
                Temporary relief requiring{' '}
                <span className="font-medium" data-id="element-194">repeat treatments</span>
              </p>
            </li>
            <li className="flex" data-id="element-195">
              <div className="text-red-500 mr-2" data-id="element-196">•</div>
              <p className="text-gray-700" data-id="element-197">
                Time away from work for appointments
              </p>
            </li>
            <li className="flex" data-id="element-198">
              <div className="text-red-500 mr-2" data-id="element-199">•</div>
              <p className="text-gray-700" data-id="element-200">
                Total annual cost:{' '}
                <span className="font-medium" data-id="element-201">$3,200-$6,400</span>
              </p>
            </li>
          </ul>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibFuPPQXcNB3dFZE21gC8v/imgi_42_gempages_581238827771757064-b43d417c-5a43-4905-89ba-bf088b3c4e71.webp" alt="Patient undergoing Lipiflow clinical treatment in a doctor's office" className="rounded-lg w-full h-auto shadow-sm" width="600" height="400" loading="lazy" data-id="element-202" />
        </div>
        <div className="md:w-1/2 bg-white p-6 rounded-lg border border-teal-200 shadow-sm" data-id="element-203">
          <div className="flex items-center mb-4" data-id="element-204">
            <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mr-4" data-id="element-205">
              <HomeIcon className="w-6 h-6 text-teal-500" data-id="element-206" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900" data-id="element-207">
              Oculis 3 At-Home Device
            </h3>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-208">
            <li className="flex" data-id="element-209">
              <div className="text-teal-500 mr-2" data-id="element-210">•</div>
              <p className="text-gray-700" data-id="element-211">
                <span className="font-medium" data-id="element-212">One-time purchase</span> of{' '}
                <span className="line-through" data-id="element-213">$149.99</span>{' '}
                <span className="font-medium" data-id="element-214">$94.99</span>
              </p>
            </li>
            <li className="flex" data-id="element-215">
              <div className="text-teal-500 mr-2" data-id="element-216">•</div>
              <p className="text-gray-700" data-id="element-217">
                Use{' '}
                <span className="font-medium" data-id="element-218">
                  daily in the comfort of your home
                </span>
              </p>
            </li>
            <li className="flex" data-id="element-219">
              <div className="text-teal-500 mr-2" data-id="element-220">•</div>
              <p className="text-gray-700" data-id="element-221">
                Many FSA/HSA accounts{' '}
                <span className="font-medium" data-id="element-222">cover the cost</span>
              </p>
            </li>
            <li className="flex" data-id="element-223">
              <div className="text-teal-500 mr-2" data-id="element-224">•</div>
              <p className="text-gray-700" data-id="element-225">
                <span className="font-medium" data-id="element-226">Ongoing treatment</span> without
                additional costs
              </p>
            </li>
            <li className="flex" data-id="element-227">
              <div className="text-teal-500 mr-2" data-id="element-228">•</div>
              <p className="text-gray-700" data-id="element-229">Use while listening to podcasts or meditating</p>
            </li>
            <li className="flex" data-id="element-230">
              <div className="text-teal-500 mr-2" data-id="element-231">•</div>
              <p className="text-gray-700" data-id="element-232">
                Total annual cost: <span className="font-medium" data-id="element-233">$0</span> after
                initial purchase
              </p>
            </li>
            {/* Grey Box for Key Benefit */}
          <div className="bg-gray-100 p-4 rounded-lg text-gray-800 mb-6" data-id="element-234">
  <p data-id="element-235">
    <span className="font-semibold text-teal-600" data-id="element-236">Oculis-3</span> was designed to capture the same core benefit 
    using consistent therapeutic <span className="font-semibold" data-id="element-237">42°C heat</span> + gentle acupressure 
    but in a simple 15-minute ritual you can do at home.
  </p>
          </div>
          </ul>
          <div className="grid grid-cols-2 gap-4" data-id="element-238">
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="h-full" data-id="element-239">
              <div className="h-full" data-id="element-240">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nnBkgD3xxAwQvZjBJpTwN/Gemini_Generated_Image_pzxzompzxzompzxz.webp" alt="Woman wearing Oculis 3 device with text showing 104-113°F constant temperature hot compress and diagram illustrating same temperature range as Lipiflow treatment" className="rounded-lg w-full h-full object-cover cursor-pointer shadow-sm" width="750" height="500" loading="lazy" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Oculis+3+Device';
              }} data-id="element-241" />
              </div>
            </a>
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="h-full" data-id="element-242">
              <div className="h-full" data-id="element-243">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfGsvgNpVxVLUYBEyPmFUE/imgi_6_imgi_85_711Xha8JqbL._AC_SL1500_ab464591-5e30-4280-9f98-76cdeacd02ac.webp" alt="Woman wearing Oculis 3 device showing kneading and compression massage techniques for comfortable eye therapy" className="rounded-lg w-full h-full object-cover cursor-pointer shadow-sm" width="750" height="500" loading="lazy" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Oculis+3+In+Use';
              }} data-id="element-244" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>;
}